// Which course groups a tab renders, and which group carries the type heading.
// Pure so the My Courses page and its stories share one definition instead of
// each hand-rolling the tab -> groups mapping.
//
// `section` is the heading key (see courseSectionCopy); null suppresses it so
// the Transcript heading spans the add + transcripted groups rather than
// repeating above each.

// Unenrolled courses land in the same 'Past Courses' bucket as expired ones
// (sessionInitializer), so they're told apart by enrollment status here.
// Accepts both the raw enrollment (_enrollmentStatus) and flattened card props.
export const isUnenrolled = (course) =>
  `${course?._enrollmentStatus ?? course?.enrollmentStatus ?? ''}`.toLowerCase() === 'inactive';

export function courseGroupsFor(tab, sections = {}) {
  const { current = [], upcoming = [], transcriptToAdd = [], transcripted = [], past = [] } = sections;

  const cur = { key: 'cur', title: 'My Current Courses', section: 'current', courses: current };
  const upc = { key: 'upc', title: 'My Upcoming Courses', section: 'upcoming', courses: upcoming };
  const add = { key: 'add', title: 'Add to Transcript', section: 'transcript', courses: transcriptToAdd };
  // Only the first transcript group shows the heading.
  const tsc = {
    key: 'tsc',
    title: 'Transcripted Courses',
    section: transcriptToAdd.length ? null : 'transcript',
    courses: transcripted
  };
  // Both keep the 'Past Courses' title: it drives the card's action-free
  // rendering. Only the heading above them differs.
  const exp = { key: 'exp', title: 'Past Courses', section: 'expired', courses: past.filter((c) => !isUnenrolled(c)) };
  const unr = { key: 'unr', title: 'Past Courses', section: 'unenrolled', courses: past.filter(isUnenrolled) };

  const nonEmpty = (g) => g.courses.length > 0;

  if (tab === 'current') return [cur].filter(nonEmpty);
  if (tab === 'upcoming') return [upc].filter(nonEmpty);
  // "past" merges the old Transcript and Expired tabs (Figma 1307-10047).
  if (tab === 'past') return [add, tsc, exp, unr].filter(nonEmpty);

  // "all": every type stacked, each under its own heading
  return [cur, upc, add, tsc, exp, unr].filter(nonEmpty);
}
